/**
 * Contains all logic related to the short-lived access token
 * Its value is stored in memory for security reasons.
 */
let cachedAccessToken: string | null = null;

/** Retrieve the access token from memory. */
export const getAccessToken = () => cachedAccessToken;

/** Store the access token in memory. */
export const setAccessToken = (token: string) => {
  cachedAccessToken = token;
};

/** Clear the in-memory access token. */
export const clearAccessToken = () => {
  cachedAccessToken = null;
};
